import {NgModule} from '@angular/core';
import {TextareaComponent} from './item';
import {IonicModule} from '@ionic/angular';
import {NgClass, NgIf, NgStyle} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SimpleMaskModule} from '@initru/ngx-ion-simple-mask';
import {DirectivesModule} from '../../../core/directives/directives.module';
import {IconComponentModule} from '../../ui/icon/item.module';

@NgModule({
  imports: [
    IonicModule,
    NgStyle,
    NgClass,
    NgIf,
    SimpleMaskModule,
    FormsModule,
    ReactiveFormsModule,
    DirectivesModule,
    IconComponentModule
  ],
  exports: [
    TextareaComponent
  ],
  declarations: [TextareaComponent],
  providers: [],
})
export class TextareaComponentModule {
}
